import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const INSPECTION_BASE = config.api.REACT_APP_SPED_NORMATIVE_API_URL;

const apiClient = new APIClient();

const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

export const getBreachRecordList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['breach_date:desc', 'creation_date:desc'],
		...params,
	};

	return apiClient.get(
		`${INSPECTION_BASE}${url.GET_BREACH_RECORDS}?${stringifyParams(queryParams)}`
	);
};

export const addNewBreachRecordApi = breachRecord => {
	return apiClient.create(`${INSPECTION_BASE}${url.POST_BREACH_RECORD}`, breachRecord);
};

export const updateBreachRecordApi = breachRecord => {
	return apiClient.put(
		`${INSPECTION_BASE}${url.PUT_BREACH_RECORD}${breachRecord._id}`,
		breachRecord
	);
};

export const deleteBreachRecordApi = breachRecordId => {
	return apiClient.delete(`${INSPECTION_BASE}${url.DELETE_BREACH_RECORD}${breachRecordId}`);
};

export const getBreachRecordListQuery = params => {
	return apiClient.get(
		`${INSPECTION_BASE}${url.GET_BREACH_RECORDS}?${stringifyParams(params)}`
	);
};

export const getBreachRecordByIdApi = id => {
	return apiClient.get(`${INSPECTION_BASE}${url.GET_BREACH_RECORD}${id}`);
};
